import { IResponse } from '../interfaces/responses.interface';
import { ISmallFleet, IUpdatePayload } from '../interfaces/small-fleet.interface';
import { API } from './config-service.api';

export const updateSmallFleet = (
    id: string,
    data: IUpdatePayload,
): Promise<IResponse<ISmallFleet>> => API.put(`/small-fleets/${id}`, data);
